// @flow

import * as React from 'react';
import TubeInput from './TubeInput';

import type {TubeDiameterCallback, TubeMaterialCallback} from "./TubeInput";
import type {OptionList} from "../common/OptionManager";
import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import ReactAI from 'react-appinsights';
import AddButton from "./AddButton";

export type NumTubesCallback = (numVariableName: string) => void;

type Props = {
    numTubes: number,
    numTubesName: string,

    namePrefix: string,
    minTubes: number,
    maxTubes: number,
    values: {[valueName: string]: number},
    metas: {[valueName: string]: ComponentMeta},
    tubeTypes: OptionList,

    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,
    addTube: NumTubesCallback,
    removeTube: NumTubesCallback,
    tubeMaterialCallback?: TubeMaterialCallback,
    tubeDiameterCallback: TubeDiameterCallback,
    
    isNoDig: boolean,

    diaByTubeType?: number[],
    requireSmallerDia?: boolean,
    
    htmlHelpType?: string,
    htmlHelpMaterial?: string,
    htmlHelpDia?: string,
    htmlHelpLength?: string,
    
    phaseNr: number
    
};

class TubesInput extends React.Component<Props> {

    render() {
        const numTubes = this.props.numTubes;
        const numTubesName = this.props.numTubesName;

        const namePrefix = this.props.namePrefix;
        const minTubes = this.props.minTubes;
        const maxTubes = this.props.maxTubes;
        const values = this.props.values;
        const metas = this.props.metas;
        const tubeTypes = this.props.tubeTypes;
        
        const onChange = this.props.onChange;
        const onBlur = this.props.onBlur;
        const onUnmount = this.props.onUnmount;
        const addTube = this.props.addTube;
        const removeTube = this.props.removeTube;
        const tubeMaterialCallback = this.props.tubeMaterialCallback;
        const tubeDiameterCallback = this.props.tubeDiameterCallback;

        const tubeRange = [...Array(numTubes+1).keys()].slice(1); // [1, 2, ... numTubes]

        let tubeLevelTexts = ['', 'underst', 'mitten', 'överst'];
        
        return <div className="tubes-wrapper">
            {
                tubeRange.map(idx => (<div key={idx}>
                    <h6>Rör {idx}
                        &nbsp;({tubeLevelTexts[idx] + (this.props.isNoDig ? " för denna teknik" : "") }) 
                        {idx > minTubes && idx === numTubes ?
                            <small className="print-hide"><a   style={{cursor: "pointer", textDecoration: "none"}}
                                        onClick={() => removeTube(numTubesName)}> - Ta bort</a></small>
                            : null}
                    </h6>
                    <TubeInput namePrefix={namePrefix + idx} 
                               values={values}
                               metas={metas}
                               htmlHelpType={this.props.htmlHelpType}
                               htmlHelpMaterial={this.props.htmlHelpMaterial}
                               htmlHelpDia={this.props.htmlHelpDia}
                               htmlHelpLength={this.props.htmlHelpLength}
                               tubeMaterialCallback={tubeMaterialCallback}
                               tubeDiameterCallback={tubeDiameterCallback}
                               tubeTypes={tubeTypes}
                               onChange={onChange}
                               onBlur={onBlur}
                               onUnmount={onUnmount}
                               phaseNr={this.props.phaseNr}
                               minDiameter={this.props.diaByTubeType && !this.props.requireSmallerDia && values[namePrefix + idx + 'TubeType'] ? 
                                   this.props.diaByTubeType[values[namePrefix + idx + 'TubeType']] : undefined}
                               maxDiameter={this.props.diaByTubeType && this.props.requireSmallerDia === true && values[namePrefix + idx + 'TubeType'] ? 
                                   this.props.diaByTubeType[values[namePrefix + idx + 'TubeType']] : undefined}
                    />
                </div>))
            }
            {numTubes < maxTubes && <AddButton text="Lägg till rör" onClick={() => addTube(numTubesName)}>Lägg till rör</AddButton>}
        </div>
    }

}

export default ReactAI.withTracking(TubesInput);



// WEBPACK FOOTER //
// ./src/components/TubesInput.js